import OpportunityCategorisation from "./components/OpportunityCategorisation";
export default OpportunityCategorisation;